"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnDateSortConfig = void 0;
const react_1 = require("react");
const date_fns_1 = require("date-fns");
const useColumnDateSortConfig = () => {
    const getSortConfig = (0, react_1.useCallback)(({ key }) => ({
        key,
        handler: (direction) => (a, b) => {
            const dateA = (0, date_fns_1.parseJSON)(a[key]);
            const dateB = (0, date_fns_1.parseJSON)(b[key]);
            return direction === 0 /* SortDirection.Ascending */ ? (0, date_fns_1.compareAsc)(dateA, dateB) : (0, date_fns_1.compareDesc)(dateA, dateB);
        },
    }), []);
    return getSortConfig;
};
exports.useColumnDateSortConfig = useColumnDateSortConfig;
